import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';
import {
  CustomerReconciliationReport,
  SupplierReconciliationReport,
  CustomerTransactionHistory
} from '../../interface/ledger/ledger-system';

@Injectable({
  providedIn: 'root'
})
export class LedgerReconciliationService {
  constructor(private http: HttpService) { }

  getCustomerReconciliation(params?: {
    customerId?: number;
    asOfDate?: string;
    pageSize?: number;
    pageNumber?: number;
  }): Promise<CustomerReconciliationReport> {
    const q = new URLSearchParams();
    if (params?.customerId) q.set('customerId', String(params.customerId));
    if (params?.asOfDate) q.set('asOfDate', params.asOfDate);
    if (params?.pageSize) q.set('pageSize', String(params.pageSize));
    if (params?.pageNumber) q.set('pageNumber', String(params.pageNumber));
    const qs = q.toString();
    return firstValueFrom(this.http.get(`/ledgerreconciliation/customers${qs ? '?' + qs : ''}`));
  }

  getSupplierReconciliation(params?: {
    supplierId?: number;
    asOfDate?: string;
    pageSize?: number;
    pageNumber?: number;
  }): Promise<SupplierReconciliationReport> {
    const q = new URLSearchParams();
    if (params?.supplierId) q.set('supplierId', String(params.supplierId));
    if (params?.asOfDate) q.set('asOfDate', params.asOfDate);
    if (params?.pageSize) q.set('pageSize', String(params.pageSize));
    if (params?.pageNumber) q.set('pageNumber', String(params.pageNumber));
    const qs = q.toString();
    return firstValueFrom(this.http.get(`/ledgerreconciliation/suppliers${qs ? '?' + qs : ''}`));
  }

  syncCustomerLedger(customerId: number, fromDate?: string): Promise<any> {
    const qs = fromDate ? `?fromDate=${fromDate}` : '';
    return firstValueFrom(this.http.post(`/ledgerreconciliation/customers/${customerId}/sync${qs}`, {}));
  }

  syncSupplierLedger(supplierId: number, fromDate?: string): Promise<any> {
    const qs = fromDate ? `?fromDate=${fromDate}` : '';
    return firstValueFrom(this.http.post(`/ledgerreconciliation/suppliers/${supplierId}/sync${qs}`, {}));
  }

  getCustomerHistory(customerId: number, fromDate?: string, toDate?: string): Promise<CustomerTransactionHistory> {
    const q = new URLSearchParams();
    if (fromDate) q.set('fromDate', fromDate);
    if (toDate) q.set('toDate', toDate);
    const qs = q.toString();
    return firstValueFrom(this.http.get(`/ledgerreconciliation/customers/${customerId}/history${qs ? '?' + qs : ''}`));
  }
}
